(function () {
  function variantPickerFromWrap(wrap) {
    var root = wrap.closest("[data-variant-picker]");
    return root ? root.querySelector("variant-picker") : null;
  }

  function secondPickerField(picker) {
    var fields = picker.querySelectorAll("[data-picker-field]");
    return fields[1] || null;
  }

  function setSecondOptionToDefault(picker, defaultVal) {
    if (!picker || defaultVal == null || defaultVal === "") return;
    var field = secondPickerField(picker);
    if (!field) return;
    var type = field.getAttribute("data-picker-field");

    if (type === "radio") {
      var inputs = field.querySelectorAll('input[type="radio"]');
      var match = null;
      inputs.forEach(function (inp) {
        if (inp.value === defaultVal) match = inp;
      });
      if (match && !match.checked) {
        match.checked = true;
        match.dispatchEvent(new Event("change", { bubbles: true }));
      }
    } else {
      var sel = field.querySelector("select");
      if (sel && sel.value !== defaultVal) {
        sel.value = defaultVal;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches("[data-extra-volume-checkbox]")) return;

    var wrap = t.closest("[data-extra-volume-wrap]");
    if (!wrap) return;

    var panel = wrap.querySelector("[data-extra-volume-panel]");
    var picker = variantPickerFromWrap(wrap);
    var defaultVal = wrap.getAttribute("data-default-no-extra");
    if (defaultVal == null) return;

    if (t.checked) {
      if (panel) panel.classList.remove("hidden");
    } else {
      if (panel) panel.classList.add("hidden");
      setSecondOptionToDefault(picker, defaultVal);
    }
  });
})();
